import { DiscountBrandType } from "src/Modules/Discounts/types";
import { RCItemType } from "src/types/RCItemType";
import BaseApi from "src/store/apis/BaseApi";
const PrivateAPIWithTags = BaseApi.enhanceEndpoints({
  addTagTypes: ["userDetails"],
});


export const GiftcardApis = PrivateAPIWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<{ categories: { code: string; name: string }[]; count: number }, any>({
      keepUnusedDataFor: 600,
      query: ({ Page, PageSize }) => {
        return {
          url: `v1.0/Category`,
          method: "POST",
          body: { Page, PageSize },
        };
      },
      transformResponse: (response: any) => {
        return {
          categories: response.result.data,
          count: response.result.count,
        };
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getGiftcardDetails: builder.query<RCItemType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `v1.0/item/Details`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response.result.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getDiscountDetails: builder.query<RCItemType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `v1.0/item/Details`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response.result.data;
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getDiscountsWithDetails: builder.query<DiscountBrandType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => {
        return {
          url: `v1.0/item/WithDetails`,
          method: "POST",
          body,
        };
      },
      transformResponse: (response: any) => {
        return response.result.data
      },
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
    getGiftcardsWithDetails: builder.query<DiscountBrandType[], any>({
      keepUnusedDataFor: 600,
      query: (body) => ({
        url: `v1.0/item/WithDetails`,
        method: "POST",
        body,
      }),
      transformResponse: (response: any) => response.result.data,
      extraOptions: { notifyOnFailure: true },
    }),
    orderItem: builder.mutation<any, any>({
      query: (body) => ({
        url: `Order/Checkout`,
        method: "POST",
        body,
      }),
      transformResponse: (response: any) => {
        return response?.result;
      },
      invalidatesTags: ["userDetails"],
      extraOptions: {
        notifyOnFailure: true,
      },
    }),
  }),
});

type GiftcardsApiEndpoints = keyof typeof GiftcardApis.endpoints;

export { type GiftcardsApiEndpoints };
export const { useGetCategoriesQuery, useGetDiscountDetailsQuery, useGetDiscountsWithDetailsQuery, useOrderItemMutation, useGetGiftcardDetailsQuery, useGetGiftcardsWithDetailsQuery} = GiftcardApis;
